import { createSlice } from '@reduxjs/toolkit';
import { INotification } from '../notifications-interfaces';
import { getHiddenDataNumber } from '../../../../domain/hidden-data-provider';
import { CSSProperties } from 'react';

interface IState {
    isOpened: boolean;
    isLoading: boolean;
    count: number;
    notifications: INotification[];
    selectedItemGuid: string;
    additionalOpenedMenuNotification: INotification|null;
    additionalOpenedMenuStyles: CSSProperties|null;
}

const initialState: IState = {
    isOpened: false,
    isLoading: true,
    count: getHiddenDataNumber('user-notifications-count') || 0,
    notifications: [],
    selectedItemGuid: '',
    additionalOpenedMenuNotification: null,
    additionalOpenedMenuStyles: null,
};

const rootSlice = createSlice({
    name: 'root',
    initialState,
    reducers: {

        main(state, action) {
            return {
                ...state,
                ...action.payload,
            }
        },
    }
});

export default rootSlice;